export enum URLStateType {
    FILTERS = 'filters',
    PAGINATION = 'pagination',
    SORT = 'sort',
    ENVIRONMENT = 'env',
    WORKFLOW_ID = 'workflowId',
    COLUMNS = 'columns',
}
